import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type UserSurveyTranslations = {
  [lang: string]: Translation;
};

export const userSurveyTranslations: UserSurveyTranslations = {
  en,
};
